<template>
  <div class="hotSaleBlock">
    <div class="hotSaleWrap pcHotSaleWrap">
      <div class="swiperBox">
        <swiper ref="pcHotSwiper" :options="hotOption">
          <swiper-slide v-for="(item, index) in hotSaleData" :key="index">
            <div class="hotSwiper">
              <div class="hotItem" :style="{ background: it.color }" v-for="(it, i) in item" :key="i">
                <a :href="`/products/${it.id}`" target="_blank">
                  <img :src="it.src" />
                </a>
              </div>
            </div>
          </swiper-slide>
          <div class="pcHotPagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="hotSaleWrap mbHotSaleWrap">
      <div class="swiperBox">
        <swiper ref="mbHotSwiper" :options="hotOption1">
          <swiper-slide v-for="(item, index) in hotSaleData" :key="index">
            <div class="hotSwiper">
              <div class="hotItem" v-for="(it, i) in item" :key="i">
                <div class="imgBox" :style="{ background: it.color }">
                  <a :href="`/products/${it.id}`">
                    <img :src="it.src" :alt="it.alt" />
                  </a>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="mbHotPagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="blogBtn">
      <a href="/products/tag/hot" target="_blank">Show more ></a>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'HotSaleBlock',
  data() {
    // const that = this
    return {
      hotOption: {
        // on: {
        //   slideChange: function() {
        //     that.hotIndex = this.realIndex
        //   }
        // },
        pagination: {
          el: '.pcHotPagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true
      },
      hotOption1: {
        // on: {
        //   slideChange: function() {
        //     that.hotIndex = this.realIndex
        //   }
        // },
        pagination: {
          el: '.mbHotPagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true
      },
      hotIndex: 0,
      hotSaleData: [
        [
          {
            color: '#D6F3CD',
            name: '',
            id: '1009',
            src: require('@/assets/homePage/hotSale_1.png'),
            alt: 'Custom Throw Pillow'
          },
          {
            color: '#EFEEC6',
            name: '',
            id: '669',
            src: require('@/assets/homePage/hotSale_2.png'),
            alt: 'Custom bags'
          },
          {
            color: '#F3DFCD',
            name: '',
            id: '1952',
            src: require('@/assets/homePage/hotSale_3.png'),
            alt: 'Custom meal bag'
          },
          {
            color: '#A9D4D6',
            name: '',
            id: '863',
            src: require('@/assets/homePage/hotSale_4.png'),
            alt: 'Custom beach pants'
          }
        ],
        [
          {
            color: '#D6F3CD',
            name: '',
            id: '1152',
            src: require('@/assets/homePage/hotSale_5.png'),
            alt: 'Custom pajamas'
          },
          {
            color: '#F5D2E9',
            name: '',
            id: '2171',
            src: require('@/assets/homePage/hotSale_6.png'),
            alt: 'Custom Hawaiian shirt'
          },
          {
            color: '#C6E4EF',
            name: '',
            id: '2091',
            src: require('@/assets/homePage/hotSale_7.png'),
            alt: 'Custom fisherman hat'
          },
          {
            color: '#CDE1F3',
            name: '',
            id: '1575',
            src: require('@/assets/homePage/hotSale_8.png'),
            alt: 'Custom schoolbag'
          }
        ]
      ]
    }
  },
  computed: {},
  components: { Swiper, SwiperSlide },
  watch: {},
  methods: {},
  mounted() {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
.hotSaleBlock {
  .hotSaleWrap {
    padding: 0 108px;
    &.mbHotSaleWrap {
      display: none;
    }
    .hotSwiper {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      .hotItem {
        width: 278px;
        height: 356px;
        font-size: 0;
        text-align: center;
        line-height: 356px;
        cursor: pointer;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .blogBtn {
    padding-top: 60px;
    text-align: center;
    a {
      display: inline-block;
      width: 200px;
      height: 60px;

      box-shadow: 0px 12px 26px 1px #f9c684;
      border-radius: 8px 8px 8px 8px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      line-height: 60px;
      background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
      cursor: pointer;
    }
  }
  .pcHotPagination {
    padding-top: 46px;
    position: initial !important;
    text-align: center;
    /deep/.swiper-pagination-bullet {
      width: 43px !important;
      height: 10px !important;
      margin: 0 8px !important;
      border-radius: 0px !important;
      background: #ffffff !important;
      opacity: 1 !important;
    }
    /deep/.swiper-pagination-bullet-active {
      background: #f48900 !important;
    }
  }
}

@media screen and (max-width: 960px) {
  .hotSaleBlock {
    .hotSaleWrap {
      padding: 0;
      &.pcHotSaleWrap {
        display: none;
      }
      &.mbHotSaleWrap {
        display: block;
      }
      .hotSwiper {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .hotItem {
          width: 50%;
          padding: 4px;
          height: auto;
          font-size: 0;
          line-height: 1;
          text-align: center;
          .imgBox {
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
      }
    }
    .blogBtn {
      padding-top: 10px;
      a {
        display: inline-block;
        width: 100%;
        height: 40px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
        box-shadow: 0px 4px 8px 1px #f9c684;
        cursor: pointer;
      }
    }
    .mbHotPagination {
      padding: 6px 0 !important;
      position: initial !important;
      text-align: center;
      /deep/.swiper-pagination-bullet {
        width: 15px !important;
        height: 4px !important;
        margin: 0 4px !important;
        border-radius: 0px !important;
        background: #fff !important;
        opacity: 1 !important;
      }
      /deep/.swiper-pagination-bullet-active {
        background: #f48900 !important;
      }
    }
  }
}
</style>
